import { ReactNode } from 'react';
import { CustomTable } from '@mybonum/ui';
import { useSearchParams } from 'react-router';

import { IPaginatedTableProps } from './types.ts';

import { URL_PARAMS } from '@/constants/url-params.ts';
import { usePagination } from '@/hooks/use-pagination.ts';

export function PaginatedTable<T>({
    loading,
    dataSource,
    columns,
    total,
}: IPaginatedTableProps<T>): ReactNode {
    const [searchParams, setSearchParams] = useSearchParams();
    const { pagination } = usePagination();

    return (
        <CustomTable<T>
            scroll={{ x: 300 }}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            onChange={(pagination, _, sorter) => {
                const newParams = new URLSearchParams(searchParams.toString());

                const { current } = pagination;
                if (current === 1) {
                    newParams.delete(URL_PARAMS.PAGE);
                } else {
                    newParams.set(URL_PARAMS.PAGE, String(current));
                }
                if (!Array.isArray(sorter)) {
                    if (sorter.order) {
                        newParams.set(
                            URL_PARAMS.SORT_DIRECTION,
                            sorter.order === 'descend' ? 'desc' : 'asc'
                        );
                    } else {
                        newParams.delete(URL_PARAMS.SORT_DIRECTION);
                    }

                    if (sorter.field) {
                        newParams.set(URL_PARAMS.SORT_BY, sorter.field.toString());
                    } else {
                        newParams.delete(URL_PARAMS.SORT_BY);
                    }
                } else {
                    newParams.delete(URL_PARAMS.SORT_DIRECTION);
                    newParams.delete(URL_PARAMS.SORT_BY);
                }

                setSearchParams(newParams);
            }}
            pagination={{
                current: pagination.page,
                pageSize: pagination.per_page,
                total: total || 0,
            }}
        />
    );
}
